import * as React from 'react';

import { SkillCategoryInterface } from './interfaces';

interface AllSkillCategoriesAndSubCategoriesContextType {
  allSkillCategories: SkillCategoryInterface[];
  allSkillSubCategories: SkillCategoryInterface[];
}

interface AllSkillCategoriesAndSubCategoriesProviderProps {
  allSkillCategories: SkillCategoryInterface[];
  allSkillSubCategories: SkillCategoryInterface[];
  children: React.ReactNode;
}

const AllSkillCategoriesAndSubCategoriesContext =
  React.createContext<AllSkillCategoriesAndSubCategoriesContextType | undefined>(undefined);

export function AllSkillCategoriesAndSubCategoriesProvider(
  props: AllSkillCategoriesAndSubCategoriesProviderProps
) {
  const { allSkillCategories, allSkillSubCategories, children } = props;

  const value = React.useMemo(
    () => ({
      allSkillCategories,
      allSkillSubCategories,
    }),
    [allSkillCategories, allSkillSubCategories]
  );

  return (
    <AllSkillCategoriesAndSubCategoriesContext.Provider value={value}>
      {children}
    </AllSkillCategoriesAndSubCategoriesContext.Provider>
  );
}

export function useAllSkillCategoriesAndSubCategoriesContext(): AllSkillCategoriesAndSubCategoriesContextType {
  const context = React.useContext(AllSkillCategoriesAndSubCategoriesContext);

  if (!context) {
    throw new Error(
      'useAllSkillCategoriesAndSubCategoriesContext must be used within an AllSkillCategoriesAndSubCategoriesProvider'
    );
  }

  return context;
}
